/*
 * ॐ नमः शिवाय
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * saveFile — the browser-side "put this in the user's Downloads folder" step,
 * shared by every export in the admin.
 *
 * Extracted from downloadTemplate so the page-config JSON export and the
 * HTML/CSS template ZIP do not each carry their own copy of the anchor dance,
 * which is fiddly enough to get subtly wrong twice.
 */

/**
 * A slug is a path — "my-home/test-world" is a real, two-segment page — so it
 * cannot go straight into a filename. Separators become dashes, and anything
 * else unusual is stripped.
 */
export function safeFileName(raw, extension) {
  const cleaned = String(raw || '')
    .replace(/[^a-zA-Z0-9._-]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return `${cleaned || 'download'}${extension}`;
}

/** Save a Blob under `filename`. */
export function saveBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Revoking in the same tick can cancel the download before it starts.
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

/** Save a JS object as a pretty-printed .json file. */
export function saveJson(data, filename) {
  saveBlob(
    new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' }),
    filename,
  );
}
